import React, { useState } from 'react'
import SelectFieldFormGroup from '../common/form/select_field_form_group'
import TextFieldFormGroup from '../common/form/text_field_form_group'

const investorTypes = ['private_party', 'corporate_entity'].sort().map((i) => ({ investorType: i }))

const InvestorInformationStep = (props) => {
  const { data } = props

  const [values, setValues] = useState({
    signer_type: data.signer_type || '',
    investor_type: data.investor_type || '',
    notes: data.notes || '',
  })

  const handleInputChange = (e) => {
    const updatedValues = { ...values, [e.target.name]: e.target.value }
    setValues(updatedValues)
    props.handleChange('investorInformationStep', 'transactionIdentity', updatedValues)
  }

  return (
    <div className='investor-information-step'>
      <h2 className='text-center'>Investor Information</h2>
      <div className='row'>
        <div className='col-md-6'>
          {/* <SelectFieldFormGroup value={values.signer_type} */}
          {/*  autoFocus */}
          {/*  controlId='signer_type' */}
          {/*  controlLabel='Signer Type' */}
          {/*  data={signerTypes} */}
          {/*  propName={'signerType'} */}
          {/*  name={'signer_type'} */}
          {/*  handleFieldChange={handleInputChange} /> */}

          <SelectFieldFormGroup
            value={values.investor_type}
            autoFocus
            controlId='investor_type'
            controlLabel='Investor Type'
            data={investorTypes}
            propName={'investorType'}
            name={'investor_type'}
            handleFieldChange={handleInputChange}
          />
        </div>
        <div className='col-md-6'>
          <TextFieldFormGroup
            value={values.notes}
            controlId='notes'
            name='notes'
            controlLabel='Notes'
            handleFieldChange={handleInputChange}
            style={{ height: '110px' }}
            as='textarea'
          />
        </div>
      </div>
    </div>
  )
}

export default InvestorInformationStep
